import { z } from 'zod';

// custom type to keep legacy data to bypass ensure validation
export const widgetLegacyMixedBooleanSchema = z.boolean().or(z.literal(0)).or(z.literal(1));

export type WidgetLegacyMixedBoolean = z.infer<typeof widgetLegacyMixedBooleanSchema>;
